export default __webpack_public_path__ + "static/media/agromap.f8fa7f3e.png";